import React from "react";
import noImage from "../icons/noImageIcon.svg";


const BrandCard = ({ image, name, onClick, optionsMenu, width }) => {
  const handleImageError = (e) => {
    e.target.src = noImage;
    e.target.style.width = "50px";
    e.target.style.height = "50px";
  };

  return (
    <div
      onClick={onClick}
      className="relative flex justify-center items-center p-2 shadow-[0px_6px_26px_rgba(98,107,125,0.07)] rounded-[12px] cursor-pointer w-full bg-white h-[120px]"
      style={{
        width: width || "auto", 
        minWidth: width || "initial", 
        maxWidth: width || "none", 
      }}
    >
      {/* Image Section */}
      <div className="overflow-hidden rounded-[12px] flex items-center justify-center bg-white w-[98px] h-[98px] shadow-[0px_6px_26px_rgba(98,107,125,0.07)] flex-shrink-0">
        <img
          src={image}
          alt={name}
          className=" w-full h-full object-contain "
          onError={handleImageError}
        />
      </div>

      {/* Name Section */}
      <div className="flex-grow ml-4">
        <h3 className="font-semibold text-[16px] text-[#38485C]">{name}</h3>
      </div>

      {/* Options Menu Section */}
      {optionsMenu && (
        <div className="absolute bottom-1 right-0">{optionsMenu}</div>
      )}
    </div>
  );
};

export default BrandCard;


const FamilyCard = ({ name, parentName, onClick, optionsMenu, width  }) => {
  return (
    <div
    onClick={onClick}
    className="relative flex  justify-center items-center p-2 shadow-[0px_6px_26px_rgba(98,107,125,0.07)] rounded-[12px] cursor-pointer w-full bg-white h-[85px]"
    style={{
      width: width || "auto", 
      minWidth: width || "initial", 
      maxWidth: width || "none", 
    }}
    >
      <div className="flex-grow ml-4">
      <h2 className="text-[#ACAFC6] text-[16px] font-bold"> {parentName} </h2>
      <h3 className="font-semibold text-[16px] text-[#38485C]">{name}</h3>
      </div>
      {/* Options Menu */}
      {optionsMenu && (
        <div className="absolute bottom-1 right-0">{optionsMenu}</div>
      )}
    </div>
  );
};

export { BrandCard, FamilyCard };